import React from 'react';
import PropTypes from 'prop-types';
import './Loading.scss';

/**
 * Composant Loading réutilisable avec différents variants
 * 
 * @param {string} variant - Type d'animation : 'spinner', 'dots', 'pulse', 'bars', 'skeleton'
 * @param {string} size - Taille : 'small', 'medium', 'large'
 * @param {string} color - Couleur : 'primary', 'secondary', 'white', 'dark'
 * @param {string} text - Texte à afficher sous le loader
 * @param {boolean} fullScreen - Afficher en plein écran
 * @param {boolean} inline - Afficher en ligne (pas de centrage)
 */
const Loading = ({
    variant = 'spinner',
    size = 'medium',
    color = 'primary',
    text = null,
    fullScreen = false,
    inline = false
}) => {
    const containerClass = `loading-container ${fullScreen ? 'loading-fullscreen' : ''} ${inline ? 'loading-inline' : 'loading-centered'}`;
    const loaderClass = `loading loading-${variant} loading-${size} loading-${color}`;

    return (
        <div className={containerClass}>
            <div className={loaderClass}>
                {variant === 'spinner' && (
                    <div className="loading-spinner">
                        <div className="spinner-ring"></div>
                    </div>
                )}

                {variant === 'dots' && (
                    <div className="loading-dots">
                        <span></span>
                        <span></span>
                        <span></span>
                    </div>
                )}

                {variant === 'pulse' && (
                    <div className="loading-pulse">
                        <div className="pulse-circle"></div>
                        <div className="pulse-circle"></div>
                        <div className="pulse-circle"></div>
                    </div>
                )}

                {variant === 'bars' && (
                    <div className="loading-bars">
                        <div className="bar"></div>
                        <div className="bar"></div>
                        <div className="bar"></div>
                        <div className="bar"></div>
                        <div className="bar"></div>
                    </div>
                )}

                {variant === 'skeleton' && (
                    <div className="loading-skeleton">
                        <div className="skeleton-line skeleton-title"></div>
                        <div className="skeleton-line skeleton-text"></div>
                        <div className="skeleton-line skeleton-text"></div>
                        <div className="skeleton-line skeleton-short"></div>
                    </div>
                )}
            </div>

            {text && (
                <p className={`loading-text loading-text-${color}`}>{text}</p>
            )}
        </div>
    );
};

Loading.propTypes = {
    variant: PropTypes.oneOf(['spinner', 'dots', 'pulse', 'bars', 'skeleton']),
    size: PropTypes.oneOf(['small', 'medium', 'large']),
    color: PropTypes.oneOf(['primary', 'secondary', 'white', 'dark']),
    text: PropTypes.string,
    fullScreen: PropTypes.bool,
    inline: PropTypes.bool
};

export default Loading;

